import AllocationInstructionsEmailForm from './AllocationInstructionsEmailForm';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

// Standalone Dialog wrapper for the allocation-instructions email form. Used by
// the CA detail page button and the SFDC post-provision prompt. The Add Product
// modal reuses the form directly (as a step) instead, to avoid stacking Dialogs.
const AllocationInstructionsEmailDialog = ({
  open,
  onClose,
  customerAccountId,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>
      <Typography variant="h6">Send allocation instructions</Typography>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{position: 'absolute', right: 8, top: 8}}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {open && (
        <AllocationInstructionsEmailForm
          customerAccountId={customerAccountId}
          onDone={onClose}
        />
      )}
    </DialogContent>
  </Dialog>
);

AllocationInstructionsEmailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customerAccountId: PropTypes.string.isRequired,
};

export default AllocationInstructionsEmailDialog;
